import React, { useState, useContext, useEffect, useRef } from "react";
import '../../../../ui-styles/bottomSlider/BottomSlider.css';
import '../../../../lib/ui/imageicon/Styles.css';
import "../../../doctor/doctorProfile//doctorProfile.css";
import "../../../../ui-styles/picker/picker.css";

import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import InputField from "../../../../lib/ui/inputs/Input";
import Radio from '../../../../lib/ui/radio/Radio';
import DropDown from "../../../../lib/ui/dropdown/Dropdown";
import AddrDropDown from "../../../../lib/ui/dropdown/addressDropDown";
import { LangCtx } from "../../../../lib/context";
import statesList from "../../../../config/states.json";
import citiesList from "../../../../config/cities.json";
import countriesList from "../../../../config/countries.json";
import titlesList from "../../../../config/titles.json";
import bloodgroups from "../../../../config/bloodgroup.json";
import DateFnsUtils from '@date-io/date-fns';
import
    {
        KeyboardDatePicker,
        MuiPickersUtilsProvider,
    } from '@material-ui/pickers';

//const districtList = [{ value: "Agra", label: "Agra" }, { value: "Aligarh", label: "Aligarh" }, { value: "Balarampur", label: "Balarampur" }, { value: "Banda", label: "Banda" }, { value: "Bareilly", lable: "Bareilly" }]
//const states = [{ value: 'UttarPradesh', label: "UttarPradesh" }, { value: 'Andhra Pradesh', label: "Andhra Pradesh" }, { value: "Arunachal Pradesh", label: "Arunachal Pradesh" }, { value: "", label: "" }, { value: "", label: "" },]
//const divisions = [{ value: "Agra", label: "Agra" }, { value: "Firozabad", label: "Firozabad" }, { value: "Mathura", label: "Mathura" }, { value: "Mainpuri", label: "Mainpuri" },]
//const departments = [{ value: "Ayurvedic", label: "Ayurvedic" }, { value: "Unani", label: "Unani" }, { value: "Homeopathy", label: "Homeopathy" },]
//const docSpecialist = [{ value: "Child Specialist", label: "Child Specialist" }, { value: "Gynecologist", label: "Gynecologist" }, { value: "Heart Specialist", label: "Heart Specialist" },]

const EditPatientProfile = (props) =>
{
    const { l } = useContext(LangCtx);
    const { error } = props;
    const divRef = useRef();
    const stateRef = useRef();
    const cityRef = useRef();
    const pinRef = useRef();
    const [ states, setStates ] = useState([ {
        value: "",
        label: l.select_state
    }, ]);
    const [ cities, setCities ] = useState([ {
        value: "",
        label: l.select_city
    }, ]);


    useEffect(() =>
    {
        if (props.data.country)
        {
            handleStates(props.data.country);
        }
    }, []);

    useEffect(() =>
    {
        if (props.error)
        {
            divRef.current.scroll({
                top: 0,
                behavior: "smooth"
            });
        }
    }, [ props.errorMsg ]);

    useEffect(() =>
    {
        if (error.state)
        {
            stateRef.current.focus();
        }
        if (error.city)
        {
            cityRef.current.focus();
        }
        if (error.pincode)
        {
            pinRef.current.focus();
        }
    }, [ error.state, error.city, error.pincode ]);

    useEffect(() =>
    {
        if (props.data.country)
        {
            handleStates(props.data.country);
        }
    }, [ props.data.country ]);

    useEffect(() =>
    {
        if (props.data.stateName)
        {
            handleCities(props.data.stateName);
        }
    }, [ props.data.stateName ]);

    const handleStates = (country) =>
        {
            let _statesList = statesList.filter((state) =>
            {
                return state.countryid === country;
            });
            // _statesList.unshift({
            //     value: "",
            //     label: l.no_state_selected
            // });
            _statesList.sort((a, b) => a.value < b.value ? -1 : a.value > b.value ? 1 : 0);
            setStates([ ..._statesList ]);
            setCities([{
                value: "",
                label: l.select_city
            }]);
        };
    
        const handleCities = (state) =>
        {
            let _citiesList = citiesList.filter((city) =>
            {
                return city.stateid === state;
            });
            if (_citiesList.length === 0) {
                _citiesList = [{
                    value: "",
                    label: l.no_cities_available 
                }];
            } 
            // else {
            //     _citiesList.unshift({
            //         value: "",
            //         label: l.no_city_selected
            //     });
            // }
            _citiesList.sort((a, b) => a.value < b.value ? -1 : a.value > b.value ? 1 : 0);
            setCities(_citiesList);
        };

    return (
        <div className={props.editProfile ? "btmSlider slideUp" : "btmSlider"}>
            <div className="btmSliderPaper">
                <div className="btmSliderHdr">
                    <div className="btmHeaderRow">
                        <div className="hdrTxtGroup" onClick={props.handleEditProfle}>
                            <span className="hdrBtnTxt">{l.cancel}</span>
                        </div>
                        <div className="hdrTxtGroup" >
                            <button className="hdrBtnTxt bgbtn" disabled={!!props.errorMsg} onClick={(e) => props.handleUpdatePatient(e)}>{l.save}</button> </div>
                    </div>
                </div>
                <div className="btmSliderBdy" ref={divRef}>
                    {props.errorMsg &&
                        <div className="errorBox">
                            <small className="errorTxt">{props.errorMsg}</small>
                        </div>
                    }
                    <div className="inputListGroup">
                        <form>
                            <div className="rowBlock">
                                <div className="inputRowGroup flex0 mrgRight8">
                                    <small className="inpLabel">{l.label_title}<span className="redTxt">*</span>:</small>
                                    <AddrDropDown
                                        placeholder={l.select_title}
                                        name="title"
                                        items={titlesList}
                                        value={decodeURIComponent(props.data.title)}
                                        error={error && error.title}
                                        errorMsg={error.title}
                                        onChange={(e) => props.handleChange('title', e.target.value)}
                                    />
                                </div>
                                <div className="inputRowGroup">
                                    <small className="inpLabel">{l.inp_fname}<span className="redTxt">*</span>:</small>
                                    <InputField
                                        placeholder={l.inp_fname}
                                        type="text"
                                        name="firstName"
                                        value={props.data.firstName ? props.data.firstName : ''}
                                        error={error && error.firstName}
                                        errorMsg={error.firstName}
                                        maxLength="30"
                                        onChange={(e) => props.handleChange('firstName', e.target.value)}
                                    />
                                </div>
                            </div>
                            <small className="inpLabel">{l.inp_lname}<span className="redTxt">*</span>:</small>
                            <InputField
                                placeholder={l.inp_lname}
                                type="text"
                                name="firstName"
                                value={props.data.lastName ? props.data.lastName : ''}
                                error={error && error.lastName}
                                errorMsg={error.lastName}
                                maxLength="30"
                                onChange={(e) => props.handleChange('lastName', e.target.value)}
                            />
                            <div className="inputRowFeild">
                                <p className="inputRowLabel">{l.label_gender}<span className="redTxt">*</span>:</p>
                                <div className="hozRadioGroup">
                                    <div className={props.data.gender === "male" ? "radioBtnItem radioBtnItemActive" : "radioBtnItem"} >
                                        <Radio id="male" name="gender" label={l.male} value="male" checked={props.data.gender === "male" ? true : false} onChange={(e) => props.handleChange("gender", e.target.value)} />
                                        {/* <img className={props.data.gender === "M" ? "imgIcon Sm" : "imgIcon invertGray Sm"} src="/images/icons/male.png" alt="gendericon" /> */}
                                        {/* <span>{l.male}</span> */}
                                    </div>
                                    <div className={props.data.gender === "female" ? "radioBtnItem radioBtnItemActive" : "radioBtnItem"} >
                                        <Radio id="female" name="gender" label={l.female} value="female" checked={props.data.gender === "female" ? true : false} onChange={(e) => props.handleChange("gender", e.target.value)} />
                                        {/* <img className={props.data.gender === "F" ? "imgIcon Sm" : "imgIcon invertGray Sm"} src="/images/icons/female.png" alt="gendericon" /> */}
                                        {/* <span>{l.female}</span> */}
                                    </div>
                                    <div className={props.data.gender === "others" ? "radioBtnItem radioBtnItemActive" : "radioBtnItem"} >
                                        <Radio id="others" name="gender" label={l.others} value="others" checked={props.data.gender === "others" ? true : false} onChange={(e) => props.handleChange("gender", e.target.value)} />
                                        {/* <span>{l.others}</span> */}
                                    </div>
                                </div>
                                {(error && error.gender) && <span className="inputErrorMsg">{error.gender}</span>}
                            </div>
                            <small className="inpLabel">{l.edit_phone_no}<span className="redTxt">*</span>:</small>
                            {/* <small className="inpLabel">{l.edit_phone_no}<span className="redTxt">*</span>:</small>
                            <InputField
                                placeholder={l.edit_phone_no}
                                type="text"
                                name="phone"
                                value={props.data.phone ? props.data.phone : ''}
                                onChange={(e) => props.handleChange('phone', e.target.value)}
                            />*/}
                            <PhoneInput
                                className="customPkgInput"
                                international
                                countryCallingCodeEditable={false}
                                defaultCountry="IN"
                                //   value={props?.data.phone ? props?.data.phone : '' }
                                value={props?.data?.countryCode && props?.data?.phone ? props?.data?.phone : ''}
                                maxLength="17"
                                //   error={error && error.phone}
                                //   errorMsg={error.phone}
                                onChange={(e) => props.handlePhoneChange(e)}
                            />

                            <small className="inpLabel">{l.edit_alt_phone_no}:</small>
                            <PhoneInput
                                className="customPkgInput"
                                international
                                countryCallingCodeEditable={false}
                                defaultCountry="IN"
                                maxLength="17"
                                value={props?.data?.alternatePhoneNumber ? props?.data?.alternatePhoneNumber : ''}
                                onChange={(e) => props.handleAlternatePhoneChange(e)}
                            />
                            {/* <InputField
                                placeholder={l.edit_alt_phone_no}
                                type="text"
                                name="alternatePhone"
                                value={props.data.alternatePhone ? props.data.alternatePhone : ''}
                                onChange={(e) => props.handleChange('alternatePhone', e.target.value)}
                            /> */}
                            <small className="inpLabel">{l.email}<span className="redTxt">*</span>:</small>
                            {props?.data?.email && props?.data?.email ?
                                <div className="profileSHdgn">{props?.data?.email}</div> :

                                <InputField
                                    placeholder={l.email}
                                    type="text"
                                    name="email"
                                    value={props.data.email}
                                    error={error && error.email}
                                    errorMsg={error.email}
                                    maxLength="50"
                                    onChange={(e) => props.handleChange('email', e.target.value)}
                                />

                            }
                            <small className="inpLabel">{l.dob}<span className="redTxt">*</span>:</small>
                            <div className="flexCol inputBox">
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker fullWidth
                                        className="pickerInput"
                                        inputVariant="outlined"
                                        value={props.data.dob}
                                        onChange={(date) => { date && props.handleChange('dob', date.valueOf()); }}
                                        animateYearScrolling
                                        placeholdertext={l.dob}
                                        format="dd/MM/yyyy"
                                        maxDate={new Date()}
                                    />
                                    {/* <div className="inputIconBox"><img src="/images/icons/date.png" className="invertGray" /></div> */}
                                </MuiPickersUtilsProvider>
                                {(error && error.dob) && <span className="inputErrorMsg">{error.dob}</span>}
                            </div>
                            <div className="flexCol" >
                                <small className="inpLabel">{l.blood_group}<span className="redTxt">*</span>:</small>
                                <DropDown
                                    placeholder={l.sel_blood_grp}
                                    items={bloodgroups}
                                    name="bloodgroup"
                                    value={props.data.bloodgroup ? decodeURIComponent(props.data.bloodgroup) : ''}
                                    onChange={(e) => props.handleChange('bloodgroup', encodeURIComponent(e.target.value))}
                                />
                                {(error && error.bloodgroup) && <span className="inputErrorMsg">{error.bloodgroup}</span>}
                            </div>
                            <small className="inpLabel">{l.pat_address}:</small>
                            <InputField
                                placeholder={l.pat_address}
                                type="text"
                                name="address"
                                maxLength="100"
                                value={props.data.address ? props.data.address : ''}
                                onChange={(e) => props.handleChange('address', e.target.value)}
                            />
                            {/* <small className="inpLabel">{l.select_country}<span className="redTxt">*</span>:</small> */}
                            <small className="inpLabel">{l.select_country}:</small>
                            <AddrDropDown
                                placeholder={l.select_country}
                                items={countriesList}
                                // items={countriesList}
                                value={props.data.country ? props.data.country : ''}
                                error={error && error.country}
                                errorMsg={error.country}
                                onChange={(e) => props.handleChange('country', e.target.value)}
                            />
                            {/* <small className="inpLabel">{l.select_state}<span className="redTxt">*</span>:</small> */}
                            <small className="inpLabel">{l.select_state}:</small>

                            <AddrDropDown
                                placeholder={l.select_state}
                                items={states}
                                value={props.data.stateName ? props.data.stateName : ''}
                                error={error && error.state}
                                errorMsg={error.state}
                                ref={stateRef}
                                onChange={(e) => props.handleChange('stateName', e.target.value)}
                            />
                            {/* <small className="inpLabel">{l.select_city}<span className="redTxt">*</span>:</small> */}
                            <small className="inpLabel">{l.select_city}:</small>
                            <AddrDropDown
                                placeholder={l.select_city}
                                items={cities}
                                value={props.data.city ? props.data.city : ''}
                                error={error && error.city}
                                errorMsg={error.city}
                                ref={cityRef}
                                onChange={(e) => props.handleChange('city', e.target.value)}
                            />
                            {/* <small className="inpLabel">{l.edit_pin}<span className="redTxt">*</span>:</small> */}
                            <small className="inpLabel">{l.edit_pin}</small>
                            <InputField
                                placeholder={l.edit_pin}
                                type="text"
                                name={l.edit_pin}
                                maxLength="11"
                                value={props.data.pincode ? props.data.pincode : ''}
                                error={error && error.pincode}
                                errorMsg={error.pincode}
                                ref={pinRef}
                                onChange={(e) => {
                                    const numericValue = e.target.value.replace(/\D/g, '');
                                    props.handleChange('pincode', numericValue)
                                }}
                            />
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default EditPatientProfile;
